import styles from "../../../../propertydetails.module.css";
import { Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useEffect, useState } from "react";
import { Box } from "@mui/system";

const schema = yup.object().shape({
    name: yup.string().required("This field is Required"),
    email: yup.string().required("This field is Required").email("Invalid E-mail"),
    types: yup.array().required("This field is Required").nullable()
});

const EmailSettingsForm = ({ property_id, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, setOpenAddEmail, editData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [selectedTypes, setSelectedTypes] = useState([]);

    const { handleSubmit, control, errors, setValue, setError } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (editData) {
            setValue('name', editData?.name);
            setValue('email', editData?.email);
            setValue('types', editData?.type_arr);
            setSelectedTypes(editData?.type_arr);
        }
    }, [editData, setValue]);

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);

        data = { ...data, property_id: property_id };

        return axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-emails", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setOpenAddEmail(false);
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                return { ...prev, property_emails: prev?.property_emails?.concat(response.data.data) };
            });

        }).catch((error) => {
            setLoading(false);
            if (error.response.status === 422) {
                setError("email", {
                    type: "validation",
                    message: error.response.data.message
                });

                return false;
            }
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onUpdate = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);

        data = { ...data, property_id: property_id };
        return axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-emails/" + editData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setOpenAddEmail(false);
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                let property_emails = prev?.property_emails?.map(i => {
                    if (i?.id === editData?.id)
                        return response.data.data;
                    return i;
                })
                return { ...prev, property_emails: property_emails };
            });

        }).catch((error) => {
            setLoading(false);
            if (error.response.status === 422) {
                setError("email", {
                    type: "validation",
                    message: error.response.data.message
                });

                return false;
            }
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return <div className={`${styles.AddUnitSec}`}>
        <form className={`${styles.AddLayoutForm}`} onSubmit={handleSubmit(editData ? onUpdate : onSubmit)}>
            <div className={`${styles.SMSmallSideBody} TabMainClientProfile ClientDetails`}>
                <div className={`${styles.AddUserMain}`}>
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                        <Controller
                            name={`name`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                variant="outlined"
                                label="Name*"
                            />)}
                        />
                        {errors.name && (<p className={`${styles.ErrorM}`}>{errors.name.message}</p>)}
                    </div>
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                        <Controller
                            name={`email`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                variant="outlined"
                                label="Email*"
                            />)}
                        />
                        {errors.email && (<p className={`${styles.ErrorM}`}>{errors.email.message}</p>)}
                    </div>
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Types*</InputLabel>
                            <Controller
                                name="types"
                                control={control}
                                render={(field) => (
                                    <Select
                                        labelId="demo-multiple-chip-label"
                                        id="demo-multiple-chip"
                                        multiple
                                        value={selectedTypes}
                                        onChange={(e) => {
                                            setSelectedTypes(e.target.value);
                                            setValue("types", e.target.value);
                                        }}
                                        input={<OutlinedInput id="select-multiple-chip" label="Types*" />}
                                        renderValue={(selected) => {
                                            return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {['Lease', 'Maintenance', 'Payment', 'Prospect'].map((value) => {
                                                    return selected?.indexOf(value) > -1 ? <Chip key={value} label={value} /> : null;
                                                })}
                                            </Box>
                                        }}
                                    >
                                        {['Lease', 'Maintenance', 'Payment', 'Prospect'].map((item) => (
                                            <MenuItem key={item} value={item}>
                                                <Checkbox checked={selectedTypes.indexOf(item) > -1} />
                                                <ListItemText primary={item} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                        {errors.types && (<p className={`${styles.ErrorM}`}>{errors.types.message}</p>)}
                    </div>
                </div>
            </div>
            <div className={`${styles.ButtonAction}`}>
                <button type="button" className="CancelPopupBU" onClick={(e) => setOpenAddEmail(false)}> Cancel </button>
                <button type="submit" className="SubmitPopupBU">{editData ? 'Update' : 'Add'}</button>
            </div>
        </form>
    </div>
}

export default EmailSettingsForm;